<template>
  <ContentLoader
    :language="language"
    :languageCodeList="languageCodeList"
    :page="data"
    :entityId="entityId"
    v-if="languageCodeList !== null"
  />
</template>

<script>
import ContentLoader from '@/components/page-loading-components/ContentLoader';

export default {
  name: 'DynamicPageManager',
  props: ['data', 'language', 'entityId'],
  components: {
    ContentLoader,
  },
  data() {
    return {
      page_sections: [],
      dataStore1: null,
      dataStore2: null,
      languageStore1: null,
      languageStore2: null,
      languageCodeList: null,
    };
  },
  async created() {
    this.dataStore1 = this.data;
    this.languageStore1 = this.language;
    await this.initPage();
  },
  methods: {
    async initPage() {
      //
      await this.getLanguages();
    },
    async getLanguages() {
      try {
        const res = await this.$cmsUtils.getLanguages().catch((e) => {
          // eslint-disable-next-line no-console
          console.log(e);
        });
        if (res.error) {
          throw res.error;
        } else {
          this.languageCodeList = res.map((l) => l.language_code);
        }
      } catch (e) {
        this.$cmsConsts.notificationError(`Error when getting languages ${e}`);
      }
    },
  },
  watch: {
    async data() {
      this.dataStore2 = this.data;
      this.languageStore2 = this.language;
      if (
        JSON.stringify(this.dataStore1) !== JSON.stringify(this.dataStore2) ||
        this.languageStore1 !== this.languageStore2
      ) {
        this.dataStore1 = null;
        this.languageStore1 = null;
        // await this.initPage();
      }
    },
  },
};
</script>
